


















import { Component, Vue } from 'vue-property-decorator'
import { TrackSelectWizardTargets } from '@/store/modules/trackselectwizard'
import { Track } from '@/classes/track'
import { USAGE_STAT_FEATURES } from '@/system/usage-stats'
import * as _ from 'lodash'

@Component({
  components: {
    TrackSelectWizard: require('@/components/TrackSelectWizard').default,
    CopyTextModal: require('@/components/CopyTextModal').default
  }
})
export default class Select extends Vue {
  target: any = TrackSelectWizardTargets.SocialShare
  tracks: Track[] = []

  openModal() {
    this.tracks = _.uniqBy(this.$store.getters['library/selectedTracks'] as Track[], '_id')

    ;(this.$refs.copyTextModal as any).openModal()

    window.addUsageStat(USAGE_STAT_FEATURES.SocialShare, 'open share modal')
  }

  onConfirm() {
    this.openModal()
  }
}
